import { html, LitElement } from 'lit-element';
import { aggregateStyles } from '../cssUtils.js';

/**
 * @element categorize-aggregate
 * @prop {Object} model - The model for the pie
 * @prop {Object} aggregate - The aggregate
 */
export class CategorizeAggregate extends LitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      aggregate: { type: Array, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  _renderResponses() {
    const { responses, incorrect, averageScore, partiallyCorrect, correct } =
      this.aggregate || {};

    return html`
      <span>Responses: ${responses}</span><br />
      <span>Average Score: ${averageScore ? averageScore.toFixed(2) : 0}</span
      ><br />
      <span>Correct: ${correct}</span><br />
      <span>Partially Correct: ${partiallyCorrect}</span><br />
      <span>Incorrect: ${incorrect}</span><br />
      <br />
    `;
  }

  _renderSelections() {
    const { selections } = this.aggregate || {};
    const { categories, choices } = this.model || {};

    if (!selections) return html``;

    const categoryKeys = Object.keys(selections);

    return categoryKeys.map(categoryKey => {
      const category = categories.find(cat => cat.id === categoryKey);
      const categorySelections = Object.values(selections[categoryKey]);

      return html`
        <span>For <strong>${category.label}:</strong></span>
        <br />
        ${categorySelections.map(selection => {
          const { value, count } = selection;
          const choice = choices.find(ch => ch.id === value);

          return html`
            <span>
              "${choice.content}" was selected ${count}
              time${count > 1 ? 's' : ''}
            </span>
            <br />
          `;
        })}
      `;
    });
  }

  render() {
    return html` <style>
        ${aggregateStyles}
      </style>
      <div class="aggregate">
        ${this._renderResponses()} ${this._renderSelections()}
      </div>`;
  }
}

export default CategorizeAggregate;
